import { Providers as OrderedProviders } from 'apollo-angular/graphql-types';
import { Providers } from 'generated/graphql-types';

const providersById = Object.values(OrderedProviders)
   .map((provider) => Providers[provider as keyof typeof Providers])
   .filter((provider): provider is Providers => provider != null);

export function getProviders(): Providers[] {
   return [...providersById];
}

const providerNumericIds: Record<Providers, number> = {
   [Providers.Inteliquent]: 1,
   [Providers.Lumen]: 2,
   [Providers.TimeWarner]: 3,
   [Providers.Twilio]: 4,
   [Providers.NDT]: 5,
};

export function getProviderNumericId(provider: Providers): number {
   return providerNumericIds[provider];
}

export function getProviderFromNumericId(providerId: number): Providers | undefined {
   return (Object.keys(providerNumericIds) as Providers[]).find(
      (provider) => providerNumericIds[provider] === providerId
   );
}

export function getProviderDisplayName(provider: Providers | number | null | undefined): string {
   if (provider == null) {
      return '';
   }

   return typeof provider === 'number' ? getProviderFromNumericId(provider) ?? '' : provider;
}

export function getCallCostProviders(): Providers[] {
   let providers = getProviders();
   let callCostProviders = ['Inteliquent', 'Lumen'];

   const prov = providers.filter((provider) => callCostProviders.includes(provider));
   return prov;
}

export function providerSearch(searchText: string) {
   return getProviders().filter((provider) =>
      getProviderDisplayName(provider).toUpperCase().includes(searchText.toUpperCase())
   );
}

export function providerCallCostsSearch(searchText: string) {
   return getCallCostProviders().filter((provider) => provider.toUpperCase().includes(searchText.toUpperCase()));
}
